import { IArea } from 'modules/settings/nomenclatures/area/interfaces';
import EntityApiServicePopulate from 'utils/EntityApiServicePopulate';

class AreaService extends EntityApiServicePopulate<IArea> {}

export default new AreaService('/ms-core/api/areas');
